import HttpService from './http.service';

class ProductTypesService {
  getProductTypes(params) {
    return HttpService.get('product_types', {
      params,
    })
      .then((res) => res.data);
  }

  suggestProductTypes(params) {
    return HttpService.get('product_types/suggestions', { params })
      .then((res) => res.data);
  }

  getProductType(id) {
    return HttpService.get(`product_types/${id}`)
      .then((res) => res.data);
  }

  createProductType(region) {
    return HttpService.post('product_types', region)
      .then((res) => res.data);
  }

  updateProductType(region) {
    return HttpService.patch(`product_types/${region.id}`, region)
      .then((res) => res.data);
  }

  deleteProductType(region) {
    return HttpService.delete(`product_types/${region.id}`)
      .then((res) => res.data);
  }
}

export default new ProductTypesService();
